import {BaseComponentPlus} from "react-vextensions";
import {store} from "../../../Store/index.js";
import {Observer} from "web-vcore";
import React from "react";
import {observer_mgl} from "mobx-graphlink";

export const ModelsPanel = observer_mgl(()=>{
	const uiState = store.main.tools.training;
	return (
		<>
		</>
	);
});